import { DateTime } from "luxon";
import type { ApiKeyDto } from "../../services/ApiService";
import type { ApiKey } from "../../types/ApiKey";
import ApiKeyId from "../../state/ApiKeyId";

export const toApiKey = (dto: ApiKeyDto): ApiKey => ({
  id: ApiKeyId.from(dto.id),
  name: dto.name,
  lastCharacters: dto.lastCharacters,
  createdOn: DateTime.fromISO(dto.created, { zone: "utc" }).toJSDate(),
});
